import { IconProps } from '.';

const PaintIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <g clipPath="url(#clip0_18177_142902)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.414062 1.66699C0.414062 0.976636 0.973707 0.416992 1.66406 0.416992H28.3307C29.0211 0.416992 29.5807 0.976636 29.5807 1.66699V10.0003C29.5807 10.6907 29.0211 11.2503 28.3307 11.2503H1.66406C0.973707 11.2503 0.414062 10.6907 0.414062 10.0003V1.66699ZM2.91406 2.91699V8.75033H27.0807V2.91699H2.91406ZM4.58073 15.417V12.5003H2.08073V16.667C2.08073 17.3573 2.64037 17.917 3.33073 17.917H13.7474V21.667H11.6641V31.667H18.3307V21.667H16.2474V16.667C16.2474 15.9766 15.6878 15.417 14.9974 15.417H4.58073ZM24.5511 17.8816L27.4974 14.9352L30.4438 17.8816C32.0709 19.5087 32.0709 22.1469 30.4438 23.7741C28.8166 25.4014 26.1783 25.4014 24.5511 23.7741C22.9239 22.1469 22.9239 19.5087 24.5511 17.8816Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
      </g>
      <defs>
        <clipPath id="clip0_18177_142902">
          <rect
            width="40"
            height="40"
            fill={color || 'var(--color-ui-icon-primary)'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PaintIcon;
